/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * Сервис Интранет — API
 * API внутреннего корпоративного портала
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  CreateEmployeeGroupDto,
  EmployeeGroupDto,
  MyDayDto,
  PreferencesDto,
  ProjectColorDto,
  SetProjectColorDto,
  UpdateEmployeeGroupDto,
  UpdatePreferencesDto
} from '../models';

import { apiRequest } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type meControllerEmployeeGroupsV1Response200 = {
  data: EmployeeGroupDto[]
  status: 200
}

export type meControllerEmployeeGroupsV1ResponseSuccess = (meControllerEmployeeGroupsV1Response200) & {
  headers: Headers;
};
;

export type meControllerEmployeeGroupsV1Response = (meControllerEmployeeGroupsV1ResponseSuccess)

export const getMeControllerEmployeeGroupsV1Url = () => {




  return `/api/v1/me/employee-groups`
}

/**
 * @summary Группы сотрудников для выбора соисполнителей: системные и мои
 */
export const meControllerEmployeeGroupsV1 = async ( options?: RequestInit): Promise<meControllerEmployeeGroupsV1Response> => {

  return apiRequest<meControllerEmployeeGroupsV1Response>(getMeControllerEmployeeGroupsV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getMeControllerEmployeeGroupsV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEmployeeGroupsV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerEmployeeGroupsV1>>, TError,void, TContext> => {

const mutationKey = ['meControllerEmployeeGroupsV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerEmployeeGroupsV1>>, void> = () => {


          return  meControllerEmployeeGroupsV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerEmployeeGroupsV1MutationResult = NonNullable<Awaited<ReturnType<typeof meControllerEmployeeGroupsV1>>>

    export type MeControllerEmployeeGroupsV1MutationError = unknown

    /**
 * @summary Группы сотрудников для выбора соисполнителей: системные и мои
 */
export const useMeControllerEmployeeGroupsV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerEmployeeGroupsV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof meControllerEmployeeGroupsV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerEmployeeGroupsV1MutationOptions(options), queryClient);
    }
    export type meControllerCreateEmployeeGroupV1Response200 = {
  data: EmployeeGroupDto[]
  status: 200
}

export type meControllerCreateEmployeeGroupV1ResponseSuccess = (meControllerCreateEmployeeGroupV1Response200) & {
  headers: Headers;
};
;

export type meControllerCreateEmployeeGroupV1Response = (meControllerCreateEmployeeGroupV1ResponseSuccess)

export const getMeControllerCreateEmployeeGroupV1Url = () => {




  return `/api/v1/me/employee-groups`
}

/**
 * @summary Создать свою группу сотрудников
 */
export const meControllerCreateEmployeeGroupV1 = async (createEmployeeGroupDto: CreateEmployeeGroupDto, options?: RequestInit): Promise<meControllerCreateEmployeeGroupV1Response> => {

  return apiRequest<meControllerCreateEmployeeGroupV1Response>(getMeControllerCreateEmployeeGroupV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createEmployeeGroupDto)
  }
);}





export const getMeControllerCreateEmployeeGroupV1QueryKey = (createEmployeeGroupDto?: MaybeRef<CreateEmployeeGroupDto>,) => {
    return [
    'POST', 'api','v1','me','employee-groups', createEmployeeGroupDto
    ] as const;
    }


export const getMeControllerCreateEmployeeGroupV1QueryOptions = <TData = Awaited<ReturnType<typeof meControllerCreateEmployeeGroupV1>>, TError = unknown>(createEmployeeGroupDto: MaybeRef<CreateEmployeeGroupDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerCreateEmployeeGroupV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getMeControllerCreateEmployeeGroupV1QueryKey(createEmployeeGroupDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerCreateEmployeeGroupV1>>> = ({ signal }) => meControllerCreateEmployeeGroupV1(unref(createEmployeeGroupDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerCreateEmployeeGroupV1>>, TError, TData>
}

export type MeControllerCreateEmployeeGroupV1QueryResult = NonNullable<Awaited<ReturnType<typeof meControllerCreateEmployeeGroupV1>>>
export type MeControllerCreateEmployeeGroupV1QueryError = unknown


/**
 * @summary Создать свою группу сотрудников
 */

export function useMeControllerCreateEmployeeGroupV1<TData = Awaited<ReturnType<typeof meControllerCreateEmployeeGroupV1>>, TError = unknown>(
 createEmployeeGroupDto: MaybeRef<CreateEmployeeGroupDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerCreateEmployeeGroupV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeControllerCreateEmployeeGroupV1QueryOptions(createEmployeeGroupDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type meControllerUpdateEmployeeGroupV1Response200 = {
  data: EmployeeGroupDto[]
  status: 200
}

export type meControllerUpdateEmployeeGroupV1ResponseSuccess = (meControllerUpdateEmployeeGroupV1Response200) & {
  headers: Headers;
};
;

export type meControllerUpdateEmployeeGroupV1Response = (meControllerUpdateEmployeeGroupV1ResponseSuccess)

export const getMeControllerUpdateEmployeeGroupV1Url = (groupId: string,) => {




  return `/api/v1/me/employee-groups/${groupId}`
}

/**
 * @summary Переименовать свою группу или поменять состав
 */
export const meControllerUpdateEmployeeGroupV1 = async (groupId: string,
    updateEmployeeGroupDto: UpdateEmployeeGroupDto, options?: RequestInit): Promise<meControllerUpdateEmployeeGroupV1Response> => {

  return apiRequest<meControllerUpdateEmployeeGroupV1Response>(getMeControllerUpdateEmployeeGroupV1Url(groupId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateEmployeeGroupDto)
  }
);}





export const getMeControllerUpdateEmployeeGroupV1QueryKey = (groupId: MaybeRef<string>,
    updateEmployeeGroupDto?: MaybeRef<UpdateEmployeeGroupDto>,) => {
    return [
    'PUT', 'api','v1','me','employee-groups',groupId, updateEmployeeGroupDto
    ] as const;
    }


export const getMeControllerUpdateEmployeeGroupV1QueryOptions = <TData = Awaited<ReturnType<typeof meControllerUpdateEmployeeGroupV1>>, TError = unknown>(groupId: MaybeRef<string>,
    updateEmployeeGroupDto: MaybeRef<UpdateEmployeeGroupDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerUpdateEmployeeGroupV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getMeControllerUpdateEmployeeGroupV1QueryKey(groupId,updateEmployeeGroupDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerUpdateEmployeeGroupV1>>> = ({ signal }) => meControllerUpdateEmployeeGroupV1(unref(groupId),unref(updateEmployeeGroupDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(groupId) !== null && unref(groupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerUpdateEmployeeGroupV1>>, TError, TData>
}

export type MeControllerUpdateEmployeeGroupV1QueryResult = NonNullable<Awaited<ReturnType<typeof meControllerUpdateEmployeeGroupV1>>>
export type MeControllerUpdateEmployeeGroupV1QueryError = unknown


/**
 * @summary Переименовать свою группу или поменять состав
 */

export function useMeControllerUpdateEmployeeGroupV1<TData = Awaited<ReturnType<typeof meControllerUpdateEmployeeGroupV1>>, TError = unknown>(
 groupId: MaybeRef<string>,
    updateEmployeeGroupDto: MaybeRef<UpdateEmployeeGroupDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerUpdateEmployeeGroupV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeControllerUpdateEmployeeGroupV1QueryOptions(groupId,updateEmployeeGroupDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type meControllerDeleteEmployeeGroupV1Response200 = {
  data: EmployeeGroupDto[]
  status: 200
}

export type meControllerDeleteEmployeeGroupV1ResponseSuccess = (meControllerDeleteEmployeeGroupV1Response200) & {
  headers: Headers;
};
;

export type meControllerDeleteEmployeeGroupV1Response = (meControllerDeleteEmployeeGroupV1ResponseSuccess)

export const getMeControllerDeleteEmployeeGroupV1Url = (groupId: string,) => {




  return `/api/v1/me/employee-groups/${groupId}`
}

/**
 * @summary Удалить свою группу
 */
export const meControllerDeleteEmployeeGroupV1 = async (groupId: string, options?: RequestInit): Promise<meControllerDeleteEmployeeGroupV1Response> => {

  return apiRequest<meControllerDeleteEmployeeGroupV1Response>(getMeControllerDeleteEmployeeGroupV1Url(groupId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMeControllerDeleteEmployeeGroupV1QueryKey = (groupId: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','me','employee-groups',groupId
    ] as const;
    }


export const getMeControllerDeleteEmployeeGroupV1QueryOptions = <TData = Awaited<ReturnType<typeof meControllerDeleteEmployeeGroupV1>>, TError = unknown>(groupId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerDeleteEmployeeGroupV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getMeControllerDeleteEmployeeGroupV1QueryKey(groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerDeleteEmployeeGroupV1>>> = ({ signal }) => meControllerDeleteEmployeeGroupV1(unref(groupId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(groupId) !== null && unref(groupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerDeleteEmployeeGroupV1>>, TError, TData>
}

export type MeControllerDeleteEmployeeGroupV1QueryResult = NonNullable<Awaited<ReturnType<typeof meControllerDeleteEmployeeGroupV1>>>
export type MeControllerDeleteEmployeeGroupV1QueryError = unknown


/**
 * @summary Удалить свою группу
 */

export function useMeControllerDeleteEmployeeGroupV1<TData = Awaited<ReturnType<typeof meControllerDeleteEmployeeGroupV1>>, TError = unknown>(
 groupId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerDeleteEmployeeGroupV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeControllerDeleteEmployeeGroupV1QueryOptions(groupId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type meControllerMyPreferencesV1Response200 = {
  data: PreferencesDto
  status: 200
}

export type meControllerMyPreferencesV1ResponseSuccess = (meControllerMyPreferencesV1Response200) & {
  headers: Headers;
};
;

export type meControllerMyPreferencesV1Response = (meControllerMyPreferencesV1ResponseSuccess)

export const getMeControllerMyPreferencesV1Url = () => {




  return `/api/v1/me/preferences`
}

/**
 * @summary Мои личные настройки
 */
export const meControllerMyPreferencesV1 = async ( options?: RequestInit): Promise<meControllerMyPreferencesV1Response> => {

  return apiRequest<meControllerMyPreferencesV1Response>(getMeControllerMyPreferencesV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getMeControllerMyPreferencesV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerMyPreferencesV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerMyPreferencesV1>>, TError,void, TContext> => {

const mutationKey = ['meControllerMyPreferencesV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerMyPreferencesV1>>, void> = () => {


          return  meControllerMyPreferencesV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerMyPreferencesV1MutationResult = NonNullable<Awaited<ReturnType<typeof meControllerMyPreferencesV1>>>

    export type MeControllerMyPreferencesV1MutationError = unknown

    /**
 * @summary Мои личные настройки
 */
export const useMeControllerMyPreferencesV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerMyPreferencesV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof meControllerMyPreferencesV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerMyPreferencesV1MutationOptions(options), queryClient);
    }
    export type meControllerUpdatePreferencesV1Response200 = {
  data: PreferencesDto
  status: 200
}

export type meControllerUpdatePreferencesV1ResponseSuccess = (meControllerUpdatePreferencesV1Response200) & {
  headers: Headers;
};
;

export type meControllerUpdatePreferencesV1Response = (meControllerUpdatePreferencesV1ResponseSuccess)

export const getMeControllerUpdatePreferencesV1Url = () => {




  return `/api/v1/me/preferences`
}

/**
 * @summary Изменить личные настройки (только присланные поля)
 */
export const meControllerUpdatePreferencesV1 = async (updatePreferencesDto: UpdatePreferencesDto, options?: RequestInit): Promise<meControllerUpdatePreferencesV1Response> => {

  return apiRequest<meControllerUpdatePreferencesV1Response>(getMeControllerUpdatePreferencesV1Url(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePreferencesDto)
  }
);}





export const getMeControllerUpdatePreferencesV1QueryKey = (updatePreferencesDto?: MaybeRef<UpdatePreferencesDto>,) => {
    return [
    'PUT', 'api','v1','me','preferences', updatePreferencesDto
    ] as const;
    }


export const getMeControllerUpdatePreferencesV1QueryOptions = <TData = Awaited<ReturnType<typeof meControllerUpdatePreferencesV1>>, TError = unknown>(updatePreferencesDto: MaybeRef<UpdatePreferencesDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerUpdatePreferencesV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getMeControllerUpdatePreferencesV1QueryKey(updatePreferencesDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerUpdatePreferencesV1>>> = ({ signal }) => meControllerUpdatePreferencesV1(unref(updatePreferencesDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerUpdatePreferencesV1>>, TError, TData>
}

export type MeControllerUpdatePreferencesV1QueryResult = NonNullable<Awaited<ReturnType<typeof meControllerUpdatePreferencesV1>>>
export type MeControllerUpdatePreferencesV1QueryError = unknown


/**
 * @summary Изменить личные настройки (только присланные поля)
 */

export function useMeControllerUpdatePreferencesV1<TData = Awaited<ReturnType<typeof meControllerUpdatePreferencesV1>>, TError = unknown>(
 updatePreferencesDto: MaybeRef<UpdatePreferencesDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerUpdatePreferencesV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeControllerUpdatePreferencesV1QueryOptions(updatePreferencesDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type meControllerMyProjectColorsV1Response200 = {
  data: ProjectColorDto[]
  status: 200
}

export type meControllerMyProjectColorsV1ResponseSuccess = (meControllerMyProjectColorsV1Response200) & {
  headers: Headers;
};
;

export type meControllerMyProjectColorsV1Response = (meControllerMyProjectColorsV1ResponseSuccess)

export const getMeControllerMyProjectColorsV1Url = () => {




  return `/api/v1/me/project-colors`
}

/**
 * @summary Мои личные цвета проектов
 */
export const meControllerMyProjectColorsV1 = async ( options?: RequestInit): Promise<meControllerMyProjectColorsV1Response> => {

  return apiRequest<meControllerMyProjectColorsV1Response>(getMeControllerMyProjectColorsV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getMeControllerMyProjectColorsV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerMyProjectColorsV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerMyProjectColorsV1>>, TError,void, TContext> => {

const mutationKey = ['meControllerMyProjectColorsV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerMyProjectColorsV1>>, void> = () => {


          return  meControllerMyProjectColorsV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerMyProjectColorsV1MutationResult = NonNullable<Awaited<ReturnType<typeof meControllerMyProjectColorsV1>>>

    export type MeControllerMyProjectColorsV1MutationError = unknown

    /**
 * @summary Мои личные цвета проектов
 */
export const useMeControllerMyProjectColorsV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerMyProjectColorsV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof meControllerMyProjectColorsV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerMyProjectColorsV1MutationOptions(options), queryClient);
    }
    export type meControllerSetProjectColorV1Response200 = {
  data: ProjectColorDto[]
  status: 200
}

export type meControllerSetProjectColorV1ResponseSuccess = (meControllerSetProjectColorV1Response200) & {
  headers: Headers;
};
;

export type meControllerSetProjectColorV1Response = (meControllerSetProjectColorV1ResponseSuccess)

export const getMeControllerSetProjectColorV1Url = (projectId: string,) => {




  return `/api/v1/me/project-colors/${projectId}`
}

/**
 * @summary Задать свой цвет проекта; null — вернуть общий
 */
export const meControllerSetProjectColorV1 = async (projectId: string,
    setProjectColorDto: SetProjectColorDto, options?: RequestInit): Promise<meControllerSetProjectColorV1Response> => {

  return apiRequest<meControllerSetProjectColorV1Response>(getMeControllerSetProjectColorV1Url(projectId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setProjectColorDto)
  }
);}





export const getMeControllerSetProjectColorV1QueryKey = (projectId: MaybeRef<string>,
    setProjectColorDto?: MaybeRef<SetProjectColorDto>,) => {
    return [
    'PUT', 'api','v1','me','project-colors',projectId, setProjectColorDto
    ] as const;
    }


export const getMeControllerSetProjectColorV1QueryOptions = <TData = Awaited<ReturnType<typeof meControllerSetProjectColorV1>>, TError = unknown>(projectId: MaybeRef<string>,
    setProjectColorDto: MaybeRef<SetProjectColorDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerSetProjectColorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getMeControllerSetProjectColorV1QueryKey(projectId,setProjectColorDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerSetProjectColorV1>>> = ({ signal }) => meControllerSetProjectColorV1(unref(projectId),unref(setProjectColorDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(projectId) !== null && unref(projectId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerSetProjectColorV1>>, TError, TData>
}

export type MeControllerSetProjectColorV1QueryResult = NonNullable<Awaited<ReturnType<typeof meControllerSetProjectColorV1>>>
export type MeControllerSetProjectColorV1QueryError = unknown


/**
 * @summary Задать свой цвет проекта; null — вернуть общий
 */

export function useMeControllerSetProjectColorV1<TData = Awaited<ReturnType<typeof meControllerSetProjectColorV1>>, TError = unknown>(
 projectId: MaybeRef<string>,
    setProjectColorDto: MaybeRef<SetProjectColorDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerSetProjectColorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeControllerSetProjectColorV1QueryOptions(projectId,setProjectColorDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type meControllerMeV1Response200 = {
  data: void
  status: 200
}

export type meControllerMeV1ResponseSuccess = (meControllerMeV1Response200) & {
  headers: Headers;
};
;

export type meControllerMeV1Response = (meControllerMeV1ResponseSuccess)

export const getMeControllerMeV1Url = () => {




  return `/api/v1/me`
}

/**
 * @summary Текущий пользователь из Bearer-токена
 */
export const meControllerMeV1 = async ( options?: RequestInit): Promise<meControllerMeV1Response> => {

  return apiRequest<meControllerMeV1Response>(getMeControllerMeV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getMeControllerMeV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerMeV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerMeV1>>, TError,void, TContext> => {

const mutationKey = ['meControllerMeV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerMeV1>>, void> = () => {


          return  meControllerMeV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerMeV1MutationResult = NonNullable<Awaited<ReturnType<typeof meControllerMeV1>>>

    export type MeControllerMeV1MutationError = unknown

    /**
 * @summary Текущий пользователь из Bearer-токена
 */
export const useMeControllerMeV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerMeV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof meControllerMeV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerMeV1MutationOptions(options), queryClient);
    }
    export type meControllerDayV1Response200 = {
  data: MyDayDto
  status: 200
}

export type meControllerDayV1ResponseSuccess = (meControllerDayV1Response200) & {
  headers: Headers;
};
;

export type meControllerDayV1Response = (meControllerDayV1ResponseSuccess)

export const getMeControllerDayV1Url = () => {




  return `/api/v1/me/day`
}

/**
 * @summary Мой день: задачи, встречи сегодня и мои контрольные точки
 */
export const meControllerDayV1 = async ( options?: RequestInit): Promise<meControllerDayV1Response> => {

  return apiRequest<meControllerDayV1Response>(getMeControllerDayV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getMeControllerDayV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerDayV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof meControllerDayV1>>, TError,void, TContext> => {

const mutationKey = ['meControllerDayV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerDayV1>>, void> = () => {


          return  meControllerDayV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeControllerDayV1MutationResult = NonNullable<Awaited<ReturnType<typeof meControllerDayV1>>>

    export type MeControllerDayV1MutationError = unknown

    /**
 * @summary Мой день: задачи, встречи сегодня и мои контрольные точки
 */
export const useMeControllerDayV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerDayV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof meControllerDayV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMeControllerDayV1MutationOptions(options), queryClient);
    }
